import {
  DatabaseFilled,
  SmileFilled,
  VideoCameraFilled,
} from "@ant-design/icons";
import { Card, Col, Row, Space, Typography } from "antd";
import React, { Component } from "react";

const { Title } = Typography;

export default class WelcomeCard extends Component {
  constructor() {
    super();
    this.state = {
      user: {
        name: "",
      },
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.setState({
      user,
    });
  }

  render() {
    return (
      <Card>
        <Row justify="center">
          <Space size="middle">
            <DatabaseFilled
              style={{ fontSize: "100px", color: "#2f54eb", marginTop: "24px" }}
            />
            <VideoCameraFilled
              style={{ fontSize: "100px", color: "#eb2f96", marginTop: "24px" }}
            />
            <SmileFilled
              style={{ fontSize: "100px", color: "#fadb14", marginTop: "24px" }}
            />
          </Space>
        </Row>
        <Row style={{ paddingTop: 42, paddingBottom: 42 }}>
          <Col span="24">
            <Title level={2} style={{ textAlign: "center" }}>
              Welcome {this.state.user.name.toUpperCase()}
            </Title>
            <Title
              level={5}
              style={{ width: "80%", margin: "auto", textAlign: "center" }}
            >
              Now you have full access to this site functionalities. You can
              customize this site movies, and games data trough each menu on
              sidebar.
            </Title>
          </Col>
        </Row>
      </Card>
    );
  }
}
